<div class="dropdown">
  <button class="dropdown-toggle" type="button" (click)="toggleBrandDropdown()">
    <ng-container *ngIf="!multiSelect">
      <span>{{ brandFilter === "" ? ('allBrands' | translate) : brandFilter.toUpperCase() }}</span>
    </ng-container>
    <ng-container *ngIf="multiSelect">
      <span *ngIf="brandFilters.length === 0">{{ 'allBrands' | translate }}</span>
      <span *ngIf="brandFilters.length > 0">{{ 'tyreBrandDropdown.brandsCount' | translate: { count: brandFilters.length
        } }}</span>
    </ng-container>
  </button>

  <div class="dropdown-menu brand-dropdown-menu" [class.show]="showBrandDropdown">
    <input type="text" class="brand-search-input" [placeholder]="'marketplace_tyres.searchBrandPlaceholder' | translate"
      [(ngModel)]="brandSearch" (input)="onBrandSearchChange()" />

    <div class="action-buttons" *ngIf="multiSelect">
      <button type="button" class="action-btn select-all" (click)="selectAllBrands()">
        {{ 'tyreBrandDropdown.selectAll' | translate }}
      </button>
      <button type="button" class="action-btn clear-all" (click)="clearBrandSelection()">
        {{ 'tyreBrandDropdown.clearSelection' | translate }}
      </button>
    </div>

    <div class="selected-brands-section" *ngIf="multiSelect && brandFilters.length > 0 && !brandSearch">
      <div class="selected-brands-header">
        {{ 'tyreBrandDropdown.selected' | translate }} ({{ brandFilters.length }})
      </div>
      <div class="selected-brands-chips">
        <span class="brand-chip-inline" *ngFor="let brand of brandFilters">
          {{ brand.toUpperCase() }}
          <button type="button" class="chip-remove-small" (click)="removeBrand(brand, $event)">×</button>
        </span>
      </div>
    </div>

    <a class="dropdown-item" *ngIf="!multiSelect" (click)="setBrandFilter('')">{{ 'allBrands' | translate }}</a>

    <div class="dropdown-scroll">
      <ng-container *ngFor="let entry of filteredBrandMap | keyvalue">
        <div class="brand-group-title brand-group-title-custom">
          {{ getCategoryLabel(entry.key) }}
        </div>
        <ng-container *ngFor="let brand of entry.value">
          <ng-container *ngIf="!multiSelect">
            <a class="dropdown-item" (click)="setBrandFilter(brand)">{{ brand.toUpperCase() }}</a>
          </ng-container>
          <ng-container *ngIf="multiSelect">
            <label class="dropdown-item checkbox-item" [class.is-selected]="isBrandSelected(brand)"
              (click)="$event.stopPropagation()">
              <input type="checkbox" [checked]="isBrandSelected(brand)" (change)="toggleBrand(brand, $event)" />
              <span class="checkbox-label">{{ brand.toUpperCase() }}</span>
            </label>
          </ng-container>
        </ng-container>
        <div class="h-6px"></div>
      </ng-container>
    </div>
  </div>
</div>